import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '@src/app/shared/shared.module';
import { AddressProfile } from '@src/app/shared/types/address.type';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { AddressBadgesComponent } from '../address-badges/address-badges.component';
import { AddressFeaturesComponent } from '../address-features/address-features.component';
import { AddressNftsComponent } from '../address-nfts/address-nfts.component';
import { AddressPortfolioComponent } from '../address-portfolio/address-portfolio.component';
import { AddressTransactionsComponent } from '../address-transactions/address-transactions.component';

@Component({
    selector: 'app-address-asset-transaction',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        AddressTransactionsComponent,
        NzSkeletonModule,
        AddressPortfolioComponent,
        AddressNftsComponent,
        AddressFeaturesComponent,
        AddressBadgesComponent,
    ],
    templateUrl: './address-asset-transaction.component.html',
    styleUrls: ['./address-asset-transaction.component.less'],
})
export class AddressAssetTransactionComponent implements OnInit {
    @Input() walletAddress: string;
    @Input() maxCount: number = null;
    @Input() pageType: 'profile' | 'address' = 'address';
    @Input() walletProfile: AddressProfile;
    @ViewChild(AddressNftsComponent) nftsComponent: AddressNftsComponent;

    fragments = ['traits', 'portfolio', 'nfts', 'transactions', 'badges'];

    index = 0;

    constructor(private router: Router) {}

    ngOnInit() {
        const fragment = this.router.parseUrl(this.router.url).fragment;
        const index = this.fragments.indexOf(fragment);
        if (index !== -1) {
            this.index = index;
        }
    }

    switchTab(index: number) {
        this.index = index;

        this.router.navigate([], {
            fragment: this.fragments[index],
            replaceUrl: true,
        });
    }
}
